import type { Component } from 'vue';
import CenterPopup from './CenterPopup.vue';
import Popup from './Popup.vue';

export default new Map<string, Component>([
  ['CenterPopup', CenterPopup],
  ['Popup', Popup],
]);

